import React, { useEffect } from 'react';
import { useState } from "react";
import getUrl from "../../../../../Utility/GetUrl";
import {AiOutlinePlus} from 'react-icons/ai';
import '../../../../../CSS/Dashboard/portfolio.scss';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { postData } from '../../../../../Utility/GlobalService';

const AddPortfolio = ()=>{
    const [stack,setStackValue] = useState("");
    const [portfolioImage,setPortfolioImage] = useState("");
    const [live_link,setLiveLink] = useState("");
    const [portfolioDescription,setPortfolioDescription] = useState("");
    const [technology,setTechnologyValue] = useState("");
    const [projectname,setProjectName] = useState("");
    const [technologyList,setTechnologyListValue] = useState([]);
    const addTechnology = ()=>{
        technologyList.push(technology);
        setTechnologyValue("");
    }
    const removeTechnology = (index)=>{
        const value = technologyList[index];
        setTechnologyListValue(technologyList.filter((technology)=> technology != value));
    }
    const resetFormValue = ()=>{
        setStackValue("");
        setPortfolioImage("");
        setLiveLink("");
        setPortfolioDescription("");
        setTechnologyValue("");
        setTechnologyListValue("");
    }
    const handleFormSubmit = (event)=>{
        event.preventDefault();
        // console.log('You Clicked');
        let formData = new FormData();
        formData.append('name',projectname);
        formData.append('stack',stack);
        formData.append('livelink',live_link);
        formData.append('workImage',portfolioImage);
        formData.append('technology',JSON.stringify(technologyList));
        formData.append('description',portfolioDescription);
        // console.table(formData.values());
        postData(`${getUrl()}/work`,formData);
        resetFormValue();
    }
    return (
        <div className="card mb-5">
            <div className="card-body mb-auto">
                <h5>Add Portfolio</h5>
                <form onSubmit = {handleFormSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="">Name</label>
                            <input 
                            value = {projectname}
                            onChange = {(event)=>{setProjectName(event.target.value)}}
                            type="text" className="form-control" />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Stack</label>
                            <input 
                            value = {stack}
                            onChange = {(event)=>{setStackValue(event.target.value)}}
                            type="text" className="form-control" />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Image</label>
                            <input 
                            onChange = {(event)=>{setPortfolioImage(event.target.files[0])}}
                            type="file" 
                            className="form-control" />
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="">Technology</label>
                                    <div className="row">
                                        <div className="col-md-9">
                                            <input 
                                                value = {technology}
                                                onChange = {(event)=>{setTechnologyValue(event.target.value)}}
                                                type="text" 
                                                className="form-control"/>
                                        </div>
                                        <div className="col-md-3">
                                            <button 
                                            type = "button"
                                            onClick={addTechnology}
                                            className="btn btn-sm btn-block btn-success">
                                                <AiOutlinePlus 
                                                style={{width: '20px',height: '20px'}}
                                                className="icon"/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-10">
                                            <div className="technology-list">
                                                <div className="item">
                                                {technologyList && technologyList.map((data,index)=> 
                                                    <p 
                                                    onClick = {()=>{removeTechnology(index)}}
                                                    key = {index}
                                                    className="item-content">{data}</p>
                                                )} 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="">Live Link</label>
                            <input 
                            value = {live_link}
                            onChange = {(event)=>{setLiveLink(event.target.value)}}
                            type="url" 
                            className="form-control" />
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-12">
                            <label htmlFor="">Description</label>
                            {/* <input type="textarea" row="10" className="form-control" /> */}
                            <CKEditor
                                editor={ ClassicEditor }
                                data={portfolioDescription}
                                // onReady={ editor => {
                                //     // You can store the "editor" and use when it is needed.
                                //     console.log( 'Editor is ready to use!', editor );
                                // } }
                                onChange={ ( event, editor ) => {
                                    const data = editor.getData();
                                    setPortfolioDescription(data);
                                    // console.log( { event, editor, data } );
                                } }
                            />
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-12">
                            {/* <input 
                            type="submit"
                            value = "Submit" 
                            className="btn btn-sm btn-block btn-success"/> */}
                            <button
                            type="submit"
                            className ="btn btn-sm btn-block btn-success"
                            >Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default AddPortfolio;